<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { transs } from '../../lib/locale';
import { PhInstagramLogo, PhLinkedinLogo, PhSnapchatLogo, PhTiktokLogo, PhMapPin } from '@phosphor-icons/vue';
import { computed } from 'vue';
import { useClipboard } from '@vueuse/core'
import { OFFICE_LOCATION } from '@/lib/mapLocations';
const { text, copy, copied, isSupported } = useClipboard({})
const { text: text2, copy: copy2, copied: copied2, isSupported: isSupported2 } = useClipboard()


const page = usePage();

const locale = computed(() => page.props.locale)

const staticMapUrl = computed(() => {
    const token = import.meta.env.VITE_MAPBOX_TOKEN;
    if (!token) return null;

    const { lng, lat } = OFFICE_LOCATION;
    return `https://api.mapbox.com/styles/v1/mapbox/light-v11/static/pin-s+510087(${lng},${lat})/${lng},${lat},14,0/600x400@2x?access_token=${token}`;
});

const links = [
    { title: 'about', href: '/about' },
    { title: 'influencer_marketing', href: '/influencer-marketing' },
    { title: 'blog', href: '/blog' },
    { title: 'contact', href: '/contact' },
]

</script>

<template>

    <!-- New Footer -->
    <section
        class="relative py-7 mt-[-30px]  overflow-hidden !bg-brand bg-gradient-to-tx from-brand-lightx via-zinc-100x to-whitex z-[700]">
        <div class="relative z-3 container mx-auto px-4">
            <!--
            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 lg:w-6/12 p-6">
                    <div class="flex flex-col justify-between h-full max-w-md">
                        <div class="mb-5 pb-10 md:pb-7 border-b md:border-0 border-brand-light/30">
                            <img class="h-24" :src="$page?.props?.site?.logo_footer" loading="lazy" alt="">
                        </div>
                        <div class="flex flex-col md:flex-row gap-4 mb-5 pb-10 pt-5 md:pt-0 md:pb-10 border-b md:border-0 border-brand-light/30">

                            <div @click="copy($page?.props?.site?.cr_no)" class="flex gap-4 flex-1  items-center cursor-pointer" v-if="$page?.props?.site?.cr_no">
                                <div class="w-16 h-16 rounded-xl overflow-hidden relative" :class="{'bg-brand-light' : copied , 'bg-white' : !copied }">
                                    <img v-if="!copied" class="aspect-square w-full object-cover object-center" src="/assets/images/legal/moc.png" loading="lazy" :alt="transs.get('commercial_registration_number', locale)">
                                    <PhChecks v-else :size="32" class="text-black absolute top-1/4 left-1/2 -translate-x-1/2" weight="bold" />
                                </div>
                                <div>
                                    <div class="text-[14px] text-zinc-800 mb-2"> {{ transs.get('commercial_registration_number', locale) }}</div>
                                    <div class="text-[14px] font-bold text-zinc-900" v-if="!copied">{{ $page?.props?.site?.cr_no }}</div>
                                    <div class="text-[14px] font-bold text-brand-light" v-else> {{ "تم النسخ" }} </div>
                                </div>
                            </div>

                            <div @click="copy2($page?.props?.site?.tax_no)" class="flex gap-4 flex-1 items-center cursor-pointer" v-if="$page?.props?.site?.tax_no">
                                <div class="w-16 h-16 rounded-xl overflow-hidden relative" :class="{'bg-brand-light' : copied2 , 'bg-white' : !copied2 }">
                                    <img v-if="!copied2" class="aspect-square w-full object-cover object-center" src="/assets/images/legal/vat.png" loading="lazy" :alt="transs.get('tax_number', locale)">
                                    <PhChecks v-else :size="32" class="text-black absolute top-1/4 left-1/2 -translate-x-1/2" weight="bold" />
                                </div>
                                <div>
                                    <div class="text-[14px] text-zinc-800 mb-2"> {{ transs.get('tax_number', locale) }}</div>
                                    <div class="text-[14px] font-bold text-zinc-900" v-if="!copied2">{{ $page?.props?.site?.tax_no }}</div>
                                    <div class="text-[14px] font-bold text-brand-light" v-else> {{ "تم النسخ" }} </div>
                                </div>
                            </div>

                        </div>

                        <div v-if="$page?.props?.site?.address" class="mb-5">
                            <div class="flex items-center gap-2 mb-3">
                                <PhMapPin :size="24" weight="fill" class="text-brand-light" />
                                <h3 class="font-bold text-lg text-zinc-900">
                                    {{ transs.get('our_location_office', locale) }}
                                </h3>
                            </div>
                            <p class="text-sm text-zinc-500 mb-4">
                                {{ $page?.props?.site?.address }}
                            </p>

                            <a v-if="staticMapUrl" :href="$page?.props?.site?.address_map_link" target="_blank"
                                class="group block rounded-3xl overflow-hidden shadow-[0_0_25px_rgba(213,179,255,0.6)]">
                                <img :src="staticMapUrl" alt="" loading="lazy"
                                    class="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500" />
                            </a>
                        </div>

                    </div>
                </div>


                <div class="w-full md:w-1/2 lg:w-2/12 p-6">
                    <div class="h-full">
                        <h3 class="mb-7 font-medium text-base text-zinc-900 tracking-px">
                            {{ transs.get('company',locale) }}
                        </h3>
                        <ul>
                            <li class="mb-4">
                                <Link class="font-medium text-base text-zinc-800 hover:text-brand-light hover:underline":href=" (locale == 'ar' ? '' : '/'+locale) + '/about' ">
                                    {{ transs.get('about', locale) }}
                                </Link>
                            </li>
                            <li class="mb-4">
                                <Link class="font-medium text-base text-zinc-800 hover:text-brand-light hover:underline" :href=" (locale == 'ar' ? '' : '/'+locale) + '/services' ">
                                    {{ transs.get('services', locale) }}
                                </Link>
                            </li>
                            <li class="mb-4">
                                <Link class="font-medium text-base text-zinc-800 hover:text-brand-light hover:underline" :href=" (locale == 'ar' ? '' : '/'+locale) + '/works' ">
                                    {{ transs.get('works', locale) }}
                                </Link>
                            </li>
                            <li>
                                <Link class="font-medium text-base text-zinc-800 hover:text-brand-light hover:underline" :href=" (locale == 'ar' ? '' : '/'+locale) + '/blog' ">
                                    {{ transs.get('blog', locale) }}
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>

                <div class="w-full md:w-1/2 lg:w-4/12 p-6">
                    <div class="flex flex-col justify-between h-full">
                        <div>
                            <h3 class="mb-7 font-medium text-base text-zinc-900 tracking-px">
                                {{ transs.get('contact_title',locale) }}
                            </h3>
                            <ul class="mb-6">
                                <li class="mb-4 font-medium text-base text-zinc-800" v-if="$page?.props?.site?.email">
                                    <a class="inline-block text-2xs hover:text-brand-light hover:underline" :href="'mailto:' + $page?.props?.site?.email"> {{ $page?.props?.site?.email}} </a>
                                </li>
                                <li class="mb-4 font-medium text-base text-zinc-800" v-if="$page?.props?.site?.phone">
                                    <a class="inline-block text-2xs hover:text-brand-light hover:underline" :href="'tel:' + $page?.props?.site?.phone"> {{ $page?.props?.site?.phone}} </a>
                                </li>
                                <li class="mb-4 font-medium text-base text-zinc-800" v-if="$page?.props?.site?.address">
                                    <a class="inline-block text-2xs hover:text-brand-light hover:underline" :href="$page?.props?.site?.address_map_link" target="_blank"> {{ $page?.props?.site?.address}} </a>
                                </li>

                                <div class="flex flex-wrap gap-6 items-center justify-start mt-6">
                                    <div class="w-auto" v-if="$page?.props?.site?.tiktok">
                                        <a :href="$page?.props?.site?.tiktok" target="_blank">
                                            <PhTiktokLogo class="text-zinc-800 hover:text-brand-light" :size="32" weight="duotone" />
                                        </a>
                                    </div>
                                    <div class="w-auto" v-if="$page?.props?.site?.instagram">
                                        <a :href="$page?.props?.site?.instagram" target="_blank">
                                            <PhInstagramLogo class="text-zinc-800 hover:text-brand-light" :size="32" weight="duotone" />
                                        </a>
                                    </div>
                                    <div class="w-auto" v-if="$page?.props?.site?.snapchat">
                                        <a :href="$page?.props?.site?.snapchat" target="_blank">
                                            <PhSnapchatLogo class="text-zinc-800 hover:text-brand-light" :size="32" weight="duotone" />
                                        </a>
                                    </div>
                                </div>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>
            --->
            <div class="text-center mx-auto max-w-3xl flex items-center justify-center text-white gap-2">
                <span>
                    {{ transs.get('all_rights_reserved', locale) }}
                </span>
                <span>
                    ({{ $page?.props?.site?.name }})
                </span>

                <span>
                    {{ new Date().getFullYear() }}
                    ©
                </span>
            </div>
        </div>
    </section>


    <!-- OLD Footer -->

    <section class="bg-white" v-if="1 == 2">
        <div class="pb-8 pt-6 bg-brand-accent/10">
            <div class="container px-4 mx-auto">
                <div class="flex flex-wrap -mx-4">
                    <div class="w-full lg:w-3/4 xl:w-2/3 px-4 pt-5 mb-8 lg:mb-0">
                        <div>
                            <div class="mb-3">
                                <img class="h-12" :src="$page?.props?.site?.logo" loading="lazy" alt="">
                            </div>
                            <div class="flex flex-col gap-4 min-w-64 w-max">
                                <div v-if="$page?.props?.site?.cr_no"
                                    class="bg-white/50 flex items-center gap-3 p-3 pe-6 rounded-xl shadow-sm">
                                    <span class="text-md"> {{ transs.get('commercial_registration_number', locale) }} :
                                    </span>
                                    <span class="text-md font-bold">{{ $page?.props?.site?.cr_no }}</span>
                                </div>
                                <div v-if="$page?.props?.site?.tax_no"
                                    class="bg-white/50 flex items-center gap-3 p-3 pe-6 rounded-xl shadow-sm">
                                    <span class="text-md"> {{ transs.get('tax_number', locale) }} : </span>
                                    <span class="text-md font-bold">{{ $page?.props?.site?.tax_no }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full lg:w-1/4 xl:w-1/3 px-4">
                        <div class="flex flex-wrap -mx-4">
                            <div class="w-1/2 md:w-1/2 px-4 my-5">
                                <ul class="flex flex-col gap-4">
                                    <li v-for="link in links" :key="link.title">
                                        <Link class="inline-block text-2xs hover:text-brand-secondary hover:underline"
                                            :href="locale === 'ar' ? (link.href) : ('/' + locale + (link.href != '/' ? link.href : ''))">
                                            {{ transs.get(link.title, locale) }}
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-1/2 md:w-1/2 px-4 my-5 border-s border-yellow-300">
                                <ul class="flex flex-col gap-4">
                                    <li>
                                        <Link class=" inline-block text-2xs hover:text-brand-secondary hover:underline"
                                            :href="locale === 'ar' ? '/faq' : ('/' + locale + '/faq')"> {{
                                                transs.get('faq', locale) }} </Link>
                                    </li>
                                    <li v-if="$page?.props?.site?.email">
                                        <a class="inline-block text-2xs hover:text-brand-secondary hover:underline"
                                            :href="'mailto:' + $page?.props?.site?.email"> {{
                                                $page?.props?.site?.email }} </a>
                                    </li>
                                    <li v-if="$page?.props?.site?.phone"><a
                                            class="inline-block text-2xs hover:text-brand-secondary hover:underline"
                                            :href="'tel:' + $page?.props?.site?.phone">{{ $page?.props?.site?.phone
                                            }}</a></li>
                                    <li v-if="$page?.props?.site?.address">
                                        <a target="_blank"
                                            class="inline-block text-2xs hover:text-brand-secondary hover:underline"
                                            :href="$page?.props?.site?.address_map_link">{{ $page?.props?.site?.address
                                            }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-8 pb-6 bg-white">
            <div class="containerx px-4 md:px-24 mx-auto">
                <div class="relative flex flex-wrap-reverse md:flex-wrap -mx-4 items-center justify-between">
                    <div class="lg:hidden w-full mb-8 px-4 text-center">
                        <a class="inline-block" :href="locale === 'ar' ? '/' : ('/' + locale)"
                            :title="$page?.props?.site?.name" :aria-label="$page?.props?.site?.name">
                            <img class="h-10" :src="$page?.props?.site?.logo" loading="lazy"
                                :alt="$page?.props?.site?.name">
                        </a>
                        <span class="block text-2xs text-gray-600">© {{ new Date().getFullYear() }} {{
                            $page?.props?.site?.name }}</span>
                    </div>

                    <div v-if="$page?.props?.site?.privacy_policy_link"
                        class="w-full flex items-center gap-8 sm:w-auto px-4 mb-8 sm:mb-0 text-center">
                        <Link class="inline-block me-8 text text-black hover:text-brand-secondary"
                            :title="transs.get('privacy_policy', locale)"
                            :aria-label="transs.get('privacy_policy', locale)"
                            :href="$page?.props?.locale == 'ar' ? '/page/' + $page?.props?.site?.privacy_policy_link : '/' + $page?.props?.locale + '/page/' + $page?.props?.site?.privacy_policy_link">
                            {{ transs.get('privacy_policy', locale) }}
                        </Link>
                    </div>

                    <div
                        class="hidden lg:block absolute top-1/2 start-1/2 transform -translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 px-4 text-center">
                        <a class="inline-block" :href="locale === 'ar' ? '/' : ('/' + locale)"
                            :title="$page?.props?.site?.name" :aria-label="$page?.props?.site?.name">
                            <img class="h-10" :src="$page?.props?.site?.logo" loading="lazy"
                                :alt="$page?.props?.site?.name">
                        </a>
                        <span class="block text-2xs text-gray-600">© {{ new Date().getFullYear() }} {{
                            $page?.props?.site?.name }}</span>
                    </div>
                    <div class="w-full sm:w-auto px-4">
                        <div class="flex items-center gap-x-4 justify-center">
                            <a v-if="$page?.props?.site?.tiktok" :title="transs.get('tiktok', locale)"
                                :aria-label="transs.get('tiktok', locale)"
                                class="flex w-10 h-10 items-center justify-center rounded-full bg-gray-800 transform hover:scale-110 transition duration-300 ease-in-out"
                                :href="$page?.props?.site?.tiktok" target="_blank">
                                <PhTiktokLogo :size="22" class="text-white" />
                            </a>
                            <a v-if="$page?.props?.site?.linkedin" :title="transs.get('linkedin', locale)"
                                :aria-label="transs.get('linkedin', locale)"
                                class="flex w-10 h-10 items-center justify-center rounded-full bg-gray-800 transform hover:scale-110 transition duration-300 ease-in-out"
                                :href="$page?.props?.site?.linkedin" target="_blank">
                                <PhLinkedinLogo :size="20" class="text-white" weight="bold" />

                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
